(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("GetPseudoElementContent", [
    "$window",
    function ($window) {
      return function getPseudoElementContent(el, pseudoEl) {
        if (pseudoEl !== "before" && pseudoEl !== "after") {
          throw new Error(
            'GetPseudoElementContent: pseudoEl must be "before" or "after" (got "' + pseudoEl + '" instead)'
          );
        }

        var content = $window.getComputedStyle(el, pseudoEl).getPropertyValue("content");
        var regexpIsQuoted = /"(.*?)"/;
        return regexpIsQuoted.test(content) ? content.match(regexpIsQuoted)[1] : content;
      };
    },
  ]);
})(window.angular);
